import { api } from "../api";
import { IPostAddInterest, IPostBuyPlan } from "../interfaces/Purchase";

export const postBuyPlan = async (data: IPostBuyPlan) => {
  const response = await api.post(`/web/plan/buy`, data);
  return response;
};

export const postAddInterest = async (data: IPostAddInterest) => {
  const response = await api.post(`/web/shopping-cart`, data);
  return response;
};
